import { useState, useEffect } from "react";
import { Bell, Stamp, AlertTriangle } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Spinner } from "@/components/portal/ui";
import { Button } from "@/components/ui/button";

const ICON = { customs_cleared: Stamp, route_breach: AlertTriangle };

export default function Alerts() {
  const [items, setItems] = useState([]);
  const [types, setTypes] = useState([]);
  const [type, setType] = useState("");
  const [read, setRead] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const p = new URLSearchParams();
      if (type) p.set("type", type);
      if (read !== "") p.set("read", read);
      const r = await api.get(`/notifications/history?${p.toString()}`);
      setItems(r.data.items); setTypes(r.data.types);
    } catch { /* ignore */ }
    setLoading(false);
  };
  useEffect(() => { load(); }, [type, read]); // eslint-disable-line

  return (
    <div>
      <PageHeader title="Alert History" subtitle="Full log of clearance & route-breach alerts" />
      <div className="flex flex-wrap gap-2 mb-4" data-testid="alerts-filters">
        <select value={type} onChange={(e) => setType(e.target.value)} data-testid="alerts-type" className="h-9 rounded-md border border-border bg-background px-3 text-sm">
          <option value="">All types</option>
          {types.map((t) => <option key={t.key} value={t.key}>{t.label}</option>)}
        </select>
        <select value={read} onChange={(e) => setRead(e.target.value)} data-testid="alerts-read" className="h-9 rounded-md border border-border bg-background px-3 text-sm">
          <option value="">All</option>
          <option value="false">Unread</option>
          <option value="true">Read</option>
        </select>
        <Button variant="outline" size="sm" onClick={load} data-testid="alerts-refresh" className="h-9">Refresh</Button>
      </div>
      {loading ? <Spinner /> : (
        <div className="rounded-xl border border-border bg-card divide-y divide-border" data-testid="alerts-list">
          {items.length === 0 && <p className="p-6 text-sm text-muted-foreground">No alerts match these filters.</p>}
          {items.map((n) => {
            const I = ICON[n.type] || Bell;
            return (
              <div key={n.id} className="p-4 flex gap-3" data-testid={`alert-row-${n.id}`}>
                <span className={`mt-0.5 shrink-0 ${n.type === "route_breach" ? "text-orange-500" : "text-primary"}`}><I size={16} /></span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold">{n.title}</p>
                  <p className="text-xs text-muted-foreground">{n.body}</p>
                </div>
                <div className="text-right shrink-0">
                  <span className="text-[11px] font-mono text-muted-foreground">{new Date(n.created_at).toLocaleString("en-ZA", { dateStyle: "short", timeStyle: "short" })}</span>
                  {!n.read && <span className="ml-2 inline-block w-2 h-2 rounded-full bg-primary" />}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
